import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-route',
  standalone: true,
  template: '<div></div>'
})
export class EmptyRouteComponent {
}

